import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { setUserTimeZone } from 'utils/timezone'

/**
 * Watches the signed-in user's `configuration.timezone` and makes it the zone every
 * timestamp renders in. Renders nothing itself, but bumps a state counter whenever the
 * zone changes so that React re-renders the tree below it: the formatters read the zone
 * at call time, and without a re-render already-painted timestamps would keep showing
 * the old zone until something else happened to refresh them.
 *
 * The initial (pre-render) apply happens in index.tsx from localStorage; this keeps the
 * app in sync as the profile loads or the user changes the setting, and drops back to
 * the company default on logout, when the profile is cleared.
 */
export const TimeZoneApplier = ({ children }: { children: React.ReactNode }) => {
  const timezone = useSelector((state: any) => state.auth?.profile?.configuration?.timezone) as string | undefined
  const [, setApplied] = useState(0)

  useEffect(() => {
    setUserTimeZone(timezone)
    setApplied((v) => v + 1)
  }, [timezone])

  return <>{children}</>
}
